// utils/resetStoresSearch.ts
import { AppDispatch } from "@/core/root-reducer"

type StoreWithSearch = {
  actions: {
    search: (payload: { value: string | null; columns: string[] }) => any
  }
}

export function resetStoresSearch(dispatch: AppDispatch, stores: StoreWithSearch[], columns: string[] = ["name"]) {
  stores.forEach((store) => {
    dispatch(
      store.actions.search({
        value: null,
        columns
      })
    )
  })
}
